import { render, staticRenderFns } from "./OrderCorpCard.vue?vue&type=template&id=668e9481&"
import script from "./OrderCorpCard.vue?vue&type=script&lang=js&"
export * from "./OrderCorpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports